import './RASuitabilityTestKnowledgeAlert.scss';

import React from 'react';
import { FormattedText } from 'core/i18n';

const RASuitabilityTestKnowledgeAlert = () => (
    <div role="alert" className="suitabilityTest_alert">
        <FormattedText value="suitabilityTest-warning" />
    </div>
);

export default RASuitabilityTestKnowledgeAlert;
